import styled from 'styled-components';

const HeaderWithBanner = styled.header`
    max-height: 800px;
    height: 60%;
    position: relative;
    width: 100%;
    overflow: hidden;
    text-align: center;
    display: flex;
    flex-flow: column;
    justify-content: space-around;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
`;

export default HeaderWithBanner;
